let currentIndex = 0;
        const slides = document.querySelectorAll('.new-slide');
        const dots = document.querySelectorAll('.new-dot');
        const totalSlides = slides.length;

        function showSlide(index) {
            const slider = document.querySelector('.new-slider');
            if (index >= totalSlides) {
                currentIndex = 0;
            } else if (index < 0) {
                currentIndex = totalSlides - 1;
            } else {
                currentIndex = index;
            }

            // Cambiar posición del slider
            slider.style.transform = `translateX(-${currentIndex * 100}%)`;

            // Actualizar los puntos activos
            dots.forEach(dot => dot.classList.remove('active'));
            dots[currentIndex].classList.add('active');
        }

        // Auto deslizamiento cada 3 segundos
        setInterval(() => {
            showSlide(currentIndex + 1);
        }, 3000);

        // Hacer clic en los puntos
        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                showSlide(index);
            });
        });

        // Inicializar el slider
        showSlide(currentIndex);